import { select, Store } from '@ngrx/store';
import { State } from '@app/store/state/state';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { HistoryBookingDetail } from '@user-history/entities/history-booking-detail';
import * as actions from '@abandoned-reservation/store/actions/abandoned-reservation.actions';

@Injectable()
export class AbandonedReservationFacade {

  constructor(
    private store: Store<State>
  ) { }

  public abandonedReservation$: Observable<HistoryBookingDetail> = this.store.pipe(
    map(state => state.abandonedReservationModule?.abandonedReservation)
  );

  get isLoadingCancellation$(): Observable<boolean> {
    return this.store.pipe(select(state => state.abandonedReservationModule?.ui?.isLoadingCancellation));
  }

  public fetchAbandonedReservation(): void {
    this.store.dispatch(actions.fetchAbandonedReservationAction());
  }

  public cancelAbandonedReservation(travelItineraryId: number): void {
    this.store.dispatch(actions.cancelAbandonedReservationAction({ travelItineraryId }));
  }
}
